module.exports = __webpack_public_path__ + "img/doorpostscene4.50942fb8.png";